import { render, staticRenderFns } from "./AddShipment.vue?vue&type=template&id=6ac3eafc"
import script from "./AddShipment.vue?vue&type=script&lang=js"
export * from "./AddShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports